import { UIMarket } from '@drift/common';
import { useMemo } from 'react';

export const usePerpMarkets = () => {
	const perpMarkets = useMemo(
		() => UIMarket.perpMarkets,
		[UIMarket.perpMarkets.length]
	);
	return perpMarkets;
};
